const Womensitemss = [
  {
    category: "women",
    subcategory: "T-shirts",
    name: "T-shirt boutonné à manches courtes et imprimé floral",
    price: "23.99",
    raw_price: "46.99",
    currency: "USD",
    discount: "49",
    likes_count: "313",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "Navy",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/FD/17/84b3ee75-de8d-40b2-b1f5-93c62436255b.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FD/17/84b3ee75-de8d-40b2-b1f5-93c62436255b.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BE/47/78463cb2-6cbc-4a36-ae84-0d30dd50cac7.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BE/47/78463cb2-6cbc-4a36-ae84-0d30dd50cac7.jpg",
    image_url: "",
    url: "https://fr.newchic.com/t-shirts-3666/p-1690810.html",
    id: "1690810",
    model: "SKUF40137",
  },
  {
    category: "women",
    subcategory: "Soutiens-gorge",
    name: "Plus Soutiens-gorge avec fermeture à l'avant",
    price: "15.99",
    raw_price: "40.36",
    currency: "USD",
    discount: "60",
    likes_count: "4603",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "blanc",
    variation_1_color: "gris",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/40/59/5a7513f6-548a-488a-a0f4-ac74e8f8de9d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/40/59/5a7513f6-548a-488a-a0f4-ac74e8f8de9d.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/99/DE/04761992-62f6-4181-9455-504c968536c4.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/99/DE/04761992-62f6-4181-9455-504c968536c4.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CE/14/70e9789b-d681-4ec7-ac55-2fe14897b6d6.jpg",
    url: "https://fr.newchic.com/bra-and-bra-set-4183/p-1533303.html",
    id: "1533303",
    model: "SKUC91583",
  },
  {
    category: "women",
    subcategory: "Pantalons & Shorts",
    name: "Pantalon décontracté à taille élastique de couleur unie",
    price: "25.99",
    raw_price: "50.99",
    currency: "USD",
    discount: "49",
    likes_count: "5564",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Khaki",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/18/AB/a51a8a09-8e7b-4d33-b233-38e1baeabce7.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/18/AB/a51a8a09-8e7b-4d33-b233-38e1baeabce7.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F5/3D/33a2a686-6d8f-4803-818d-91288a125f69.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F5/3D/33a2a686-6d8f-4803-818d-91288a125f69.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/05/A9/f908379b-4128-4270-8933-e724653b2a28.jpg",
    url: "https://fr.newchic.com/pants-and-capris-3674/p-1661710.html",
    id: "1661710",
    model: "SKUE94621",
  },
  {
    category: "women",
    subcategory: "Robes imprimées",
    name: "Robe midi décontractée à imprimé floral",
    price: "23.99",
    raw_price: "46.99",
    currency: "USD",
    discount: "49",
    likes_count: "1262",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Khaki",
    variation_1_color: "White",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F0/F6/e8349f09-80eb-4a64-b300-b3fdc46192c2.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F0/F6/e8349f09-80eb-4a64-b300-b3fdc46192c2.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/3A/20/bd1ec57a-875d-44ed-92e8-a7d487075dc1.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/3A/20/bd1ec57a-875d-44ed-92e8-a7d487075dc1.jpg",
    url: "https://fr.newchic.com/print-dresses-3677/p-1691484.html",
    id: "1691484",
    model: "SKUF41372",
  },
  {
    category: "women",
    subcategory: "T-shirts",
    name: "T-shirt brodé de fleurs",
    price: "15.99",
    raw_price: "38.88",
    currency: "USD",
    discount: "59",
    likes_count: "4485",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Sky Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/82/A2/d234e908-188c-4493-9f3c-9ae7a4275259.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/82/A2/d234e908-188c-4493-9f3c-9ae7a4275259.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/2D/EA/642b831d-c76d-4339-a0fc-7b3f32eed953.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2D/EA/642b831d-c76d-4339-a0fc-7b3f32eed953.jpg",
    image_url: "",
    url: "https://fr.newchic.com/t-shirts-3666/p-1655044.html",
    id: "1655044",
    model: "SKUE83526",
  },
  {
    category: "women",
    subcategory: "Robes imprimées",
    name: "Robe longue à imprimé floral vintage",
    price: "33.99",
    raw_price: "70.99",
    currency: "USD",
    discount: "52",
    likes_count: "2419",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Red",
    variation_1_color: "Yellow",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/45/EA/44f4279f-d777-4da1-903e-6820ea03b219.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/45/EA/44f4279f-d777-4da1-903e-6820ea03b219.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/3F/CB/9fbb9cf2-99d4-4cb4-aac3-1cda952f3f43.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/3F/CB/9fbb9cf2-99d4-4cb4-aac3-1cda952f3f43.jpg",

    image_url: "",
    url: "https://fr.newchic.com/print-dresses-3677/p-1527134.html",
    id: "1527134",
    model: "SKUC88481",
  },
  {
    category: "women",
    subcategory: "Combinaisons & Grenouillères",
    name: "Combinaison à bretelles à imprimé floral",
    price: "32.99",
    raw_price: "64.98",
    currency: "USD",
    discount: "49",
    likes_count: "33",
    is_new: "true",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Red",
    variation_1_color: "Navy",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/52/51/562b5bbb-5180-4d3f-8014-993d79cbef92.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/52/51/562b5bbb-5180-4d3f-8014-993d79cbef92.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A6/50/bf193e3e-d976-403b-9870-19cbb4634b12.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A6/50/bf193e3e-d976-403b-9870-19cbb4634b12.jpg",
    image_url: "",
    url: "https://fr.newchic.com/jumpsuits-and-rompers-3702/p-1715194.html",
    id: "1715194",
    model: "SKUF79731",
  },
  {
    category: "women",
    subcategory: "Combinaisons & Grenouillères",
    name: "Combinaison à bretelles à imprimé floral",
    price: "29.99",
    raw_price: "63.98",
    currency: "USD",
    discount: "53",
    likes_count: "4132",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Apricot",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C2/3C/9b01d967-a68b-4fbb-9978-ef995e171e61.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C2/3C/9b01d967-a68b-4fbb-9978-ef995e171e61.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C1/AC/f12ab12b-debe-4f5a-bacc-9e46dd280084.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C1/AC/f12ab12b-debe-4f5a-bacc-9e46dd280084.jpg",
    image_url: "",
    url: "https://fr.newchic.com/jumpsuits-and-rompers-3702/p-1660117.html",
    id: "1660117",
    model: "SKUE91643",
  },
  {
    category: "women",
    subcategory: "Pantalons & Shorts",
    name: "Pantalon décontracté à fleurs",
    price: "21.99",
    raw_price: "47.99",
    currency: "USD",
    discount: "54",
    likes_count: "3095",
    is_new: "false",
    brand: "Gracila",
    brand_url: "https://fr.newchic.com/gracila-brand-247.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Yellow",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/56/AE/d89d31a2-1fae-4779-a82c-fbbe7675c413.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/56/AE/d89d31a2-1fae-4779-a82c-fbbe7675c413.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/73/6F/1f7e62ca-4fec-4b74-bd0a-654da998a4f8.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/73/6F/1f7e62ca-4fec-4b74-bd0a-654da998a4f8.jpg",
    image_url: "",
    url: "https://fr.newchic.com/gracila-pants-and-capris-3674/p-1663956.html",
    id: "1663956",
    model: "SKUE99093",
  },
  {
    category: "women",
    subcategory: "Pantalons & Shorts",
    name: "Pantalon décontracté à cordon de couleur unie",
    price: "23.51",
    raw_price: "45.99",
    currency: "USD",
    discount: "49",
    likes_count: "4367",
    is_new: "false",
    brand: "Gracila",
    brand_url: "https://fr.newchic.com/gracila-brand-247.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Grey",
    variation_1_color: "Green",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/95/D5/3e4908bf-7df3-49e3-b055-c764441b8e84.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/95/D5/3e4908bf-7df3-49e3-b055-c764441b8e84.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/6B/EE/ad63dff1-cc0d-48f7-bb35-4bfabc14fccc.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/6B/EE/ad63dff1-cc0d-48f7-bb35-4bfabc14fccc.jpg",
    image_url: "",
    url: "https://fr.newchic.com/gracila-pants-and-capris-3674/p-1617649.html",
    id: "1617649",
    model: "SKUE10410",
  },
  {
    category: "women",
    subcategory: "Soutiens-gorge",
    name: "Soutien-gorge Sexy à Décollecté Plongeant sans Armature",
    price: "13.99",
    raw_price: "26.89",
    currency: "USD",
    discount: "48",
    likes_count: "14252",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "Violet clair",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/71/65/9d33b6c3-68f9-4e4b-96f2-103ba2e6dce1.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/71/65/9d33b6c3-68f9-4e4b-96f2-103ba2e6dce1.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F3/59/8fd7cf14-58eb-4ebc-9677-d6f8d029878e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F3/59/8fd7cf14-58eb-4ebc-9677-d6f8d029878e.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/79/AB/c0c50ea6-b10f-4063-b73e-9d1991d713f4.jpg",
    url: "https://fr.newchic.com/bra-and-bra-set-4183/p-1141004.html",
    id: "1141004",
    model: "SKU631930",
  },
  {
    category: "women",
    subcategory: "Vestes & Gilets",
    name: "Vestes à imprimé floral de style ethnique",
    price: "25.99",
    raw_price: "72.47",
    currency: "USD",
    discount: "64",
    likes_count: "4393",
    is_new: "false",
    brand: "O-NEWE",
    brand_url: "https://fr.newchic.com/o-newe-brand-465.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Red",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/16/88/e3015762-557c-4865-b38f-6c698fe0f6cb.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/16/88/e3015762-557c-4865-b38f-6c698fe0f6cb.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/EE/9B/d11716bf-22d9-4168-9a25-b24d5ef5338a.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/EE/9B/d11716bf-22d9-4168-9a25-b24d5ef5338a.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/B8/F4/cfb84662-7fe7-4fdf-8fd5-cc9e201a6408.jpg",
    url:
      "https://fr.newchic.com/o-newe-plus-size-coats-and-jackets-3957/p-1561403.html",
    id: "1561403",
    model: "SKUD02476",
  },
  {
    category: "women",
    subcategory: "T-shirts",
    name: "T-shirt simple à fleurs",
    price: "19.42",
    raw_price: "39.99",
    currency: "USD",
    discount: "51",
    likes_count: "3240",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Grey",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CF/AA/e09c4602-1d28-47ad-a429-73cadef2e1a8.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CF/AA/e09c4602-1d28-47ad-a429-73cadef2e1a8.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/99/A1/608c337d-e3ad-40d3-a788-ffb8bffede31.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/99/A1/608c337d-e3ad-40d3-a788-ffb8bffede31.jpg",
    image_url: "",
    url: "https://fr.newchic.com/t-shirts-3666/p-1654724.html",
    id: "1654724",
    model: "SKUE82280",
  },
  {
    category: "women",
    subcategory: "Robes imprimées",
    name: "Robe longue à patchwork imprimé",
    price: "28.99",
    raw_price: "73.31",
    currency: "USD",
    discount: "61",
    likes_count: "5822",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "vert",
    variation_1_color: "Jaune",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/53/74/1bf4051d-c430-405b-b5e8-de1c0cafd61c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/53/74/1bf4051d-c430-405b-b5e8-de1c0cafd61c.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/FF/A7/a8b042ff-2710-4078-85d3-15708f107748.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FF/A7/a8b042ff-2710-4078-85d3-15708f107748.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0F/5E/e1ef7c6b-9231-4e15-8a38-6f6d7fe83be8.jpg",
    url: "https://fr.newchic.com/plus-size-print-dresses-5159/p-1509346.html",
    id: "1509346",
    model: "SKUB84919",
  },
  {
    category: "women",
    subcategory: "Blouses & Chemises",
    name: "Chemisier ample à col rabattu de couleur unie",
    price: "22.99",
    raw_price: "39.58",
    currency: "USD",
    discount: "42",
    likes_count: "1306",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "Yellow",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/D7/30/ee90314e-5fde-42de-98a7-0c3ca67aeea7.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/D7/30/ee90314e-5fde-42de-98a7-0c3ca67aeea7.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/98/A8/de73f810-d351-46e1-943e-02e83c808c86.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/98/A8/de73f810-d351-46e1-943e-02e83c808c86.jpg",
    image_url: "",
    url: "https://fr.newchic.com/blouses-and-shirts-3689/p-1555575.html",
    id: "1555575",
    model: "SKUB88698",
  },
  {
    category: "women",
    subcategory: "Pantalons & Shorts",
    name: "Sarouel croisé décontracté",
    price: "16.99",
    raw_price: "48.37",
    currency: "USD",
    discount: "65",
    likes_count: "3486",
    is_new: "false",
    brand: "O-NEWE",
    brand_url: "https://fr.newchic.com/o-newe-brand-465.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/01/97/16d6b8fd-6c6f-4675-b45b-67148db91525.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/01/97/16d6b8fd-6c6f-4675-b45b-67148db91525.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/42/C8/b8aacf61-7904-4779-a0f6-fabcfd128937.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/42/C8/b8aacf61-7904-4779-a0f6-fabcfd128937.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/7E/3A/0e435d9a-fd6a-4ddf-a140-30c14e47eb45.jpg",
    url:
      "https://fr.newchic.com/o-newe-plus-size-pants-and-capris-3959/p-1667484.html",
    id: "1667484",
    model: "SKUF04567",
  },
  {
    category: "women",
    subcategory: "T-shirts",
    name: "T-shirt imprimé poisson",
    price: "17.99",
    raw_price: "39.99",
    currency: "USD",
    discount: "55",
    likes_count: "3542",
    is_new: "false",
    brand: "Gracila",
    brand_url: "https://fr.newchic.com/gracila-brand-247.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/11/EE/77350a61-52b8-4c8b-b59f-872a7b2d79fb.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/11/EE/77350a61-52b8-4c8b-b59f-872a7b2d79fb.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/24/62/5164278a-e999-4111-8e3c-fd1b015a1372.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/24/62/5164278a-e999-4111-8e3c-fd1b015a1372.jpg",
    image_url: "",
    url: "https://fr.newchic.com/gracila-t-shirts-3666/p-1656834.html",
    id: "1656834",
    model: "SKUE84599",
  },
  {
    category: "women",
    subcategory: "Blouses & Chemises",
    name: "Chemisier ample de couleur unie",
    price: "31.99",
    raw_price: "62.98",
    currency: "USD",
    discount: "49",
    likes_count: "918",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F0/7E/84a404de-e980-4d00-8d92-9812f4a9dfd2.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F0/7E/84a404de-e980-4d00-8d92-9812f4a9dfd2.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/30/1B/706a915a-304d-49ad-8665-1e89e9843046.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/30/1B/706a915a-304d-49ad-8665-1e89e9843046.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/7F/C8/61115a11-fd55-4a9d-9937-e6625eb09969.jpg",
    url: "https://fr.newchic.com/blouses-and-shirts-3689/p-1674856.html",
    id: "1674856",
    model: "SKUF15401",
  },
  {
    category: "women",
    subcategory: "Robes imprimées",
    name: "Robe midi bohème imprimée à pois",
    price: "24.99",
    raw_price: "46.99",
    currency: "USD",
    discount: "47",
    likes_count: "1730",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Grey",
    variation_1_color: "Yellow",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A1/AC/f5588ba4-5f39-4d0a-bd1e-6216170be55b.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A1/AC/f5588ba4-5f39-4d0a-bd1e-6216170be55b.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/90/EC/741364c1-6436-49a2-b483-048a36dc8b71.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/90/EC/741364c1-6436-49a2-b483-048a36dc8b71.jpg",
    image_url: "",
    url: "https://fr.newchic.com/print-dresses-3677/p-1666207.html",
    id: "1666207",
    model: "SKUE85353",
  },
  {
    category: "women",
    subcategory: "Pantalons & Shorts",
    name: "Pantalon imprimé papillons en bambou",
    price: "27.6",
    raw_price: "52.98",
    currency: "USD",
    discount: "48",
    likes_count: "2826",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Grey",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B2/06/d0b6bba4-d182-4984-b609-76c032e8e99d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B2/06/d0b6bba4-d182-4984-b609-76c032e8e99d.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BC/2E/985de441-53ef-421d-a845-3e4339943dd4.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BC/2E/985de441-53ef-421d-a845-3e4339943dd4.jpg",
    image_url: "",
    url: "https://fr.newchic.com/pants-and-capris-3674/p-1662798.html",
    id: "1662798",
    model: "SKUE97066",
  },
  {
    category: "women",
    subcategory: "Robes imprimées",
    name: "Robe mi-longue imprimée à fleurs",
    price: "21.99",
    raw_price: "42.99",
    currency: "USD",
    discount: "49",
    likes_count: "541",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Yellow",
    variation_1_color: "Grey",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/2A/75/e670eb4a-4af2-47e2-a3c3-f990d070482d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2A/75/e670eb4a-4af2-47e2-a3c3-f990d070482d.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BA/E4/065ae831-42af-4446-921d-1102ddf14628.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BA/E4/065ae831-42af-4446-921d-1102ddf14628.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/25/3C/df70512c-24ce-405e-bd0d-9444e008726d.jpg",
    url: "https://fr.newchic.com/print-dresses-3677/p-1697894.html",
    id: "1697894",
    model: "SKUF51206",
  },
  {
    category: "women",
    subcategory: "Robes imprimées",
    name: "Robe maxi sans manches imprimé patchwork",
    price: "24.99",
    raw_price: "60.84",
    currency: "USD",
    discount: "59",
    likes_count: "1690",
    is_new: "false",
    brand: "ZANZEA",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Orange",
    variation_1_color: "Khaki",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C1/5E/1620d9ce-feef-45ad-93a9-b71eec464c19.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C1/5E/1620d9ce-feef-45ad-93a9-b71eec464c19.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E0/DF/4c6c0d57-6122-41b8-bc85-bf3bca5a0695.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E0/DF/4c6c0d57-6122-41b8-bc85-bf3bca5a0695.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8D/80/7cc3c980-b550-40c6-b5b6-e686ecf665ce.jpg",
    url: "https://fr.newchic.com/plus-size-print-dresses-5159/p-1565270.html",
    id: "1565270",
    model: "SKUD10368",
  },
  {
    category: "women",
    subcategory: "Robes décontractées",
    name: "Robe longue de couleur contrastée",
    price: "26.57",
    raw_price: "48.99",
    currency: "USD",
    discount: "46",
    likes_count: "3363",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "gris",
    variation_1_color: "Bleu",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/32/95/4a6b7e59-0ffb-449e-a4d5-58ed057b5fdb.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/32/95/4a6b7e59-0ffb-449e-a4d5-58ed057b5fdb.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DC/15/4336328e-c67b-4bec-891b-5a2155ca9a96.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DC/15/4336328e-c67b-4bec-891b-5a2155ca9a96.jpg",
    image_url: "",
    url: "https://fr.newchic.com/casual-dresses-5073/p-1526607.html",
    id: "1526607",
    model: "SKUC71203",
  },
  {
    category: "women",
    subcategory: "Combinaisons & Grenouillères",
    name: "Combinaison à bretelles à imprimé floral Daisy",
    price: "29.99",
    raw_price: "59.99",
    currency: "USD",
    discount: "50",
    likes_count: "2879",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Navy",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/55/27/a176b60f-bde0-4b5d-a687-28e2039d4988.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/55/27/a176b60f-bde0-4b5d-a687-28e2039d4988.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/23/C0/a51139bb-53b7-4e6d-8f6b-79fd58de98ab.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/23/C0/a51139bb-53b7-4e6d-8f6b-79fd58de98ab.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F1/AC/107844b6-4daa-40e3-80f7-b3d8337808d1.jpg",
    url: "https://fr.newchic.com/jumpsuits-and-rompers-3702/p-1664205.html",
    id: "1664205",
    model: "SKUE99141",
  },
  {
    category: "women",
    subcategory: "Blouses & Chemises",
    name: "Chemisier à manches courtes brodé bohème",
    price: "24.99",
    raw_price: "50.99",
    currency: "USD",
    discount: "51",
    likes_count: "5012",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "blanc",
    variation_1_color: "Rose",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C1/23/707e0d3c-871b-4f48-9c0c-3243abce6b4c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C1/23/707e0d3c-871b-4f48-9c0c-3243abce6b4c.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/41/63/1b7d4726-1477-41ac-9674-ae87105d4922.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/41/63/1b7d4726-1477-41ac-9674-ae87105d4922.jpg",
    image_url: "",
    url: "https://fr.newchic.com/blouses-and-shirts-3689/p-1477083.html",
    id: "1477083",
    model: "SKUB64124",
  },
  {
    category: "women",
    subcategory: "Robes imprimées",
    name: "Robe imprimée à poches col rond",
    price: "30.66",
    raw_price: "58.98",
    currency: "USD",
    discount: "48",
    likes_count: "464",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Yellow",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CB/1C/8ac35bb1-e46f-4a19-b3ef-bbbd405766f6.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CB/1C/8ac35bb1-e46f-4a19-b3ef-bbbd405766f6.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/3B/0E/e202cdb1-9cb4-4e1c-8bf1-05b11cc03b4a.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/3B/0E/e202cdb1-9cb4-4e1c-8bf1-05b11cc03b4a.jpg",
    image_url: "",
    url: "https://fr.newchic.com/print-dresses-3677/p-1665087.html",
    id: "1665087",
    model: "SKUE91437",
  },
  {
    category: "women",
    subcategory: "Robes imprimées",
    name: "Robe longue bouffante à imprimé floral",
    price: "19.99",
    raw_price: "59.07",
    currency: "USD",
    discount: "66",
    likes_count: "1584",
    is_new: "false",
    brand: "ZANZEA",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Navy",
    variation_1_color: "Red",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/D9/D0/10d32e43-83a8-4659-b35e-03b61cdfd9e9.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/D9/D0/10d32e43-83a8-4659-b35e-03b61cdfd9e9.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/1F/63/cd2f08f2-0f1e-4b16-a69d-07f91282b3d0.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/1F/63/cd2f08f2-0f1e-4b16-a69d-07f91282b3d0.jpg",
    url: "https://fr.newchic.com/plus-size-print-dresses-5159/p-1591654.html",
    id: "1591654",
    model: "SKUD65785",
  },
  {
    category: "women",
    subcategory: "Blouses & Chemises",
    name: "Chemisier à manches longues imprimé chat ",
    price: "22.99",
    raw_price: "51.99",
    currency: "USD",
    discount: "56",
    likes_count: "4726",
    is_new: "false",
    brand: "Gracila",
    brand_url: "https://fr.newchic.com/gracila-brand-247.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/E6/D5/a9750bea-9efc-493b-9070-08f3e84e74fc.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/E6/D5/a9750bea-9efc-493b-9070-08f3e84e74fc.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/51/45/02401dbd-b6bf-433c-aa2a-4209b1d7e336.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/51/45/02401dbd-b6bf-433c-aa2a-4209b1d7e336.jpg",
    image_url: "",
    url:
      "https://fr.newchic.com/gracila-blouses-and-shirts-3689/p-1603323.html",
    id: "1603323",
    model: "SKUD81888",
  },
  {
    category: "women",
    subcategory: "Blouses & Chemises",
    name: "Chemisier col rabattu de couleur unie",
    price: "25.99",
    raw_price: "50.99",
    currency: "USD",
    discount: "49",
    likes_count: "556",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5F/21/088ad83f-5155-4df4-bd6f-e625a638b9bf.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5F/21/088ad83f-5155-4df4-bd6f-e625a638b9bf.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/28/A1/ca44a8fd-f6ca-4d71-85e2-8c1c2996e19d.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/28/A1/ca44a8fd-f6ca-4d71-85e2-8c1c2996e19d.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AF/3B/a70a79a5-c397-4012-adb0-36e3a5cf9572.jpg",
    url: "https://fr.newchic.com/blouses-and-shirts-3689/p-1691048.html",
    id: "1691048",
    model: "SKUF40335",
  },
  {
    category: "women",
    subcategory: "T-shirts",
    name: "T-shirt décontracté à fleurs",
    price: "21.99",
    raw_price: "43.88",
    currency: "USD",
    discount: "50",
    likes_count: "1346",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Grey",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6F/38/96c0ccc5-b1be-4fc8-9352-d9fb3fa86eea.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6F/38/96c0ccc5-b1be-4fc8-9352-d9fb3fa86eea.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CA/95/56d1e42e-5faa-4005-91d6-429787411ba7.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CA/95/56d1e42e-5faa-4005-91d6-429787411ba7.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/08/90/bb1eeb6d-6937-4774-b213-0141cbba874a.jpg",
    url: "https://fr.newchic.com/t-shirts-3666/p-1656117.html",
    id: "1656117",
    model: "SKUE82712",
  },
  {
    category: "women",
    subcategory: "T-shirts",
    name: "T-shirt boutonné uni",
    price: "19.99",
    raw_price: "47.99",
    currency: "USD",
    discount: "58",
    likes_count: "2442",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Orange",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/8E/03/6397767e-da0a-424b-82a8-060c37388f82.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8E/03/6397767e-da0a-424b-82a8-060c37388f82.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E5/CF/1bddd809-6386-49d6-abf9-139f3b2b012c.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E5/CF/1bddd809-6386-49d6-abf9-139f3b2b012c.jpg",
    image_url: "",
    url: "https://fr.newchic.com/t-shirts-3666/p-1651757.html",
    id: "1651757",
    model: "SKUE75118",
  },
  {
    category: "women",
    subcategory: "Combinaisons & Grenouillères",
    name: "Combinaison imprimé papillons",
    price: "30.66",
    raw_price: "52.98",
    currency: "USD",
    discount: "42",
    likes_count: "2170",
    is_new: "false",
    brand: "Gracila",
    brand_url: "https://fr.newchic.com/gracila-brand-247.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Grey",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/46/9B/dba7322b-088c-4ec5-b16b-d3e2739b7fb1.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/46/9B/dba7322b-088c-4ec5-b16b-d3e2739b7fb1.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/4A/7B/a19fb059-0321-4223-a62f-d9e0946d4719.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4A/7B/a19fb059-0321-4223-a62f-d9e0946d4719.jpg",
    url:
      "https://fr.newchic.com/gracila-jumpsuits-and-rompers-3702/p-1666185.html",
    id: "1666185",
    model: "SKUF00527",
  },
  {
    category: "women",
    subcategory: "Blouses & Chemises",
    name: "Chemisier Selvedge Stringy",
    price: "25.99",
    raw_price: "50.98",
    currency: "USD",
    discount: "49",
    likes_count: "689",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "#02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E7/CD/be2f2d8a-9f55-45ab-b52d-d3451d9cf91c.jpg",
    variation_0_image: "",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/9C/18/83bbfef5-8991-44b4-8255-11c4cbcf1631.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9C/18/83bbfef5-8991-44b4-8255-11c4cbcf1631.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E7/CD/be2f2d8a-9f55-45ab-b52d-d3451d9cf91c.jpg",
    url: "https://fr.newchic.com/blouses-and-shirts-3689/p-1674015.html",
    id: "1674015",
    model: "SKUF01390",
  },
  {
    category: "women",
    subcategory: "Chemises",
    name: "Blouse patchwork à imprimé vintage",
    price: "19.99",
    raw_price: "64.97",
    currency: "USD",
    discount: "69",
    likes_count: "8286",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Rose",
    variation_1_color: "Beige",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/7A/52/b7f238fe-f0c3-48e7-b26c-c86544390be0.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/7A/52/b7f238fe-f0c3-48e7-b26c-c86544390be0.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/08/A0/16b08062-1d0f-4fb8-b24a-ee09b78b05a1.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/08/A0/16b08062-1d0f-4fb8-b24a-ee09b78b05a1.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/C3/E9/4ea695b7-c003-4bbc-adf5-43459ea4f399.jpg",
    url:
      "https://fr.newchic.com/plus-size-blouses-and-shirts-3956/p-1430434.html",
    id: "1430434",
    model: "SKUA95544",
  },
  {
    category: "women",
    subcategory: "Robes imprimées",
    name: "Robe midi chemise boutonnée vintage",
    price: "27.27",
    raw_price: "55.38",
    currency: "USD",
    discount: "51",
    likes_count: "2951",
    is_new: "false",
    brand: "ZANZEA",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Rose",
    variation_1_color: "Noir",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/0A/7F/bc8954a1-4e20-4e65-a303-8853d615f065.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0A/7F/bc8954a1-4e20-4e65-a303-8853d615f065.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/29/12/1fe4a67c-7542-4fac-af0d-1c0eae5fdf03.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/29/12/1fe4a67c-7542-4fac-af0d-1c0eae5fdf03.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F3/11/273892ae-82cd-40da-9864-1ad51d7d4c56.jpg",
    url: "https://fr.newchic.com/print-dresses-3677/p-1472759.html",
    id: "1472759",
    model: "SKUB26315",
  },
  {
    category: "women",
    subcategory: "Pantalons & Shorts",
    name: "Pantalon décontracté à imprimé graffiti",
    price: "18.99",
    raw_price: "42.2",
    currency: "USD",
    discount: "55",
    likes_count: "1688",
    is_new: "false",
    brand: "O-NEWE",
    brand_url: "https://fr.newchic.com/o-newe-brand-465.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Red",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/31/2B/6eaede73-1fc1-4d41-913f-aa12964180e3.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/31/2B/6eaede73-1fc1-4d41-913f-aa12964180e3.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/90/26/c8841ddf-6186-4a06-af0d-05694e218f18.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/90/26/c8841ddf-6186-4a06-af0d-05694e218f18.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5E/AE/0675246d-d640-4628-888c-0779b3dcadc5.jpg",
    url:
      "https://fr.newchic.com/o-newe-plus-size-pants-and-capris-3959/p-1667379.html",
    id: "1667379",
    model: "SKUF04546",
  },
  {
    category: "women",
    subcategory: "T-shirts",
    name: "T-shirt boutonné à fleurs",
    price: "20.44",
    raw_price: "38.88",
    currency: "USD",
    discount: "47",
    likes_count: "2094",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Sky Blue",
    variation_1_color: "White",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CF/F5/41537d16-91ec-470b-9416-9985655d4590.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CF/F5/41537d16-91ec-470b-9416-9985655d4590.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/8A/1B/3982c58d-ff78-43f3-9388-5d9adb2f1ec1.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8A/1B/3982c58d-ff78-43f3-9388-5d9adb2f1ec1.jpg",
    url: "https://fr.newchic.com/t-shirts-3666/p-1661821.html",
    id: "1661821",
    model: "SKUE94881",
  },
  {
    category: "women",
    subcategory: "Robes imprimées",
    name: "Robe décontractée imprimée",
    price: "15.99",
    raw_price: "41.28",
    currency: "USD",
    discount: "61",
    likes_count: "972",
    is_new: "false",
    brand: "ZANZEA",
    brand_url: "",
    codCountry: "",
    variation_0_color: "Red",
    variation_1_color: "Green",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E1/5D/47c6547d-fc0f-4be2-8af1-de81d80ff5ae.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E1/5D/47c6547d-fc0f-4be2-8af1-de81d80ff5ae.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C3/8B/ebfce95c-2bef-4ab2-960d-3de7662a6b1f.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C3/8B/ebfce95c-2bef-4ab2-960d-3de7662a6b1f.jpg",
    url: "https://fr.newchic.com/plus-size-print-dresses-5159/p-1546066.html",
    id: "1546066",
    model: "SKUC90329",
  },
  {
    category: "women",
    subcategory: "Combinaison & Salopette",
    name: "Combinaison ample bohème à bretelles",
    price: "25.99",
    raw_price: "60.97",
    currency: "USD",
    discount: "57",
    likes_count: "3906",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "kaki",
    variation_1_color: "Noir",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C7/08/7392dbe9-8bf3-4c07-88d9-2779dcbe1b6d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C7/08/7392dbe9-8bf3-4c07-88d9-2779dcbe1b6d.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/92/62/9700f7e1-8ba3-4b35-89ac-01109c973ce8.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/92/62/9700f7e1-8ba3-4b35-89ac-01109c973ce8.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/30/34/3fb522cd-ae7c-4239-8fc9-3155d986023a.jpg",
    url:
      "https://fr.newchic.com/plus-size-jumpsuits-and-rompers-5163/p-1446771.html",
    id: "1446771",
    model: "SKUA32319",
  },
  {
    category: "women",
    subcategory: "Pantalons & Shorts",
    name: "Pantalon décontracté uni femme",
    price: "21.99",
    raw_price: "47.99",
    currency: "USD",
    discount: "54",
    likes_count: "1147",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B1/8A/4ce149db-0da4-4c62-ae9e-4e88e66bfb7f.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B1/8A/4ce149db-0da4-4c62-ae9e-4e88e66bfb7f.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5E/45/3ae72b4e-c717-45d9-bdf5-4fce950eaeb1.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5E/45/3ae72b4e-c717-45d9-bdf5-4fce950eaeb1.jpg",
    image_url: "",
    url: "https://fr.newchic.com/pants-and-capris-3674/p-1667322.html",
    id: "1667322",
    model: "SKUF04426",
  },
];

export default Womensitemss;
